/**
 * Utilitário compartilhado para formatação e enriquecimento de dados de encontros da Lily
 */
export const formatarEvento = (eventoApi) => {
  if (!eventoApi) return null;

  // Helper: parseia strings no formato 'YYYY-MM-DD' como data LOCAL
  // para evitar que o construtor Date() trate-as como UTC e cause
  // deslocamento do dia/mês dependendo do fuso horário do cliente.
  const parseDateSafe = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;

    // Se for string YYYY-MM-DD
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
      const [y, m, d] = value.split('T')[0].split('-');
      // Forçamos a criação da data usando os componentes isolados
      // O UTC não será usado, ele criará a data baseada no calendário local
      return new Date(
        parseInt(y, 10),
        parseInt(m, 10) - 1,
        parseInt(d, 10),
        12,
        0,
        0,
      );
    }

    return new Date(value);
  };

  const dataBase = eventoApi.dias?.[0]?.dataInicio
    ? parseDateSafe(eventoApi.dias[0].dataInicio)
    : parseDateSafe(eventoApi.referenceMonth) ||
      parseDateSafe(eventoApi.startDate) ||
      new Date();
  const mesNome = new Intl.DateTimeFormat('pt-BR', { month: 'long' })
    .format(dataBase)
    .toUpperCase();

  // Formata o horário de exibição geral (ex: baseado no primeiro dia cadastrado)
  const horarioGeral = new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(dataBase);

  // Transforma o array cru de EventoDia nos dados visuais e interativos que o seletor precisa
  const diasFormatados =
    eventoApi.dias?.map((dia) => {
      const d = parseDateSafe(dia.dataInicio) || new Date(dia.dataInicio);
      return {
        id: dia.id, // O ID único gerado pelo Supabase para usarmos na key
        numero: d.getDate(),
        semana: new Intl.DateTimeFormat('pt-BR', { weekday: 'short' })
          .format(d)
          .replace('.', ''),
        horario: new Intl.DateTimeFormat('pt-BR', {
          hour: '2-digit',
          minute: '2-digit',
        }).format(d),
        esgotado: dia.vagasOcupadas >= dia.vagas,
      };
    }) || [];

  return {
    ...eventoApi,
    mesNome,
    horario: horarioGeral,
    diasFormatados,
    // O backend agora mapeia e devolve diretamente o array de strings de urls
    galeriaImagens: eventoApi.imagens || [],
  };
};
